import { inject, Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

@Pipe({
  name: 'bypassSecurityTrustUrl',
  standalone: true,
  pure: true,
})
export class BypassSecurityTrustUrlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer)

  transform(value: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value)
  }
}
